// extracted by mini-css-extract-plugin
export default {"thumbnailWrapper":"VideoThumbnail_thumbnailWrapper__tCiVg","thumbnail":"VideoThumbnail_thumbnail__vjLuO"};